import React, { useState } from "react";
import { Link } from "react-router-dom";
import gallery from "../../api/gallery";
import "./Gallerysection.css";


const GallerySection = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    const openModal = (image) => {
        setSelectedImage(image);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };
    return (
        <section className="wpo-instagram-section s2 section-padding">
            <img src="" alt="" />
            <div className="container">
                    <div className="gallery-grid">
                        {gallery.map((item, idx) => {
                            const areaClass = idx < 12 ? `area-${idx + 1}` : "";
                            return (
                                <div
                                    className={`gallery-item ${areaClass}`}
                                    key={item.id}
                                >
                                    <div className="instagram-card">
                                        <div className="image">
                                            <Link
                                                to={item.imag}
                                                className="fancybox"
                                                data-fancybox-group="gall-1"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    openModal(item.imag);
                                                }}
                                            >
                                                <img
                                                    src={item.imag}
                                                    alt={`Instagram ${item.id}`}
                                                    className="img img-responsive"
                                                />
                                                {/* <div className="popup-icon">
                                                    <i className="ti-plus"></i>
                                                </div> */}
                                            </Link>
                                        </div>
                                        {/* <div className="text">
                                            <span>{item.title}</span>
                                            <h2>{item.subtitle}</h2>
                                        </div> */}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
            </div>
            {modalOpen && (
                <div className="modal" onClick={closeModal}>
                    <div className="modal-wrap">
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <span className="close" onClick={closeModal}>
                                &times;
                            </span>
                            <img src={selectedImage} alt="Modal" />
                        </div>
                    </div>
                </div>
            )}
        </section>
    )
}

export default GallerySection;